<template>
  <div class="pt-8">
    <h3 class="text-lg">{{type}} Certification</h3>
    <div class="pt-3">
      <div class="rounded-full bg-smoke-100 flex items-center py-2 border border-dark-b px-3">
        <input
          class="app-input bg-smoke-100 flex-grow text-center"
          :placeholder="`${type} Certifications...`"
          v-model="keyword"
        >
        <i class="icon-search opacity-50"></i>
      </div>
      <div v-if="!certificatesList.length && !extraSupplierCertificatesCheck && keyword" class="pt-3 text-red-700 text-center text-sm">No Results Found</div>
    </div>
    <div class="pt-5">
      <div :class="{'max-h-44 overflow-auto': !showAll}">
        <template v-if="type === 'Supplier'">
          <div v-if="!keyword.length || 'duns'.includes(keyword.toLowerCase())" class="flex items-center py-1 checkbox-wrapper" @click="selectDuns">
            <input
              type="checkbox"
              :value="true"
              class="w-5 h-5"
              v-model="duns"
            >
            <span class="checkmark" />
            <span class="pl-4">DUNS</span>
          </div>
          <div v-if="!keyword.length || 'drs'.includes(keyword.toLowerCase())" class="flex items-center py-1 checkbox-wrapper" @click="selectDrs">
            <input
              type="checkbox"
              :value="true"
              class="w-5 h-5"
              v-model="drs"
            >
            <span class="checkmark" />
            <span class="pl-4">DRS</span>
          </div>
        </template>
        <div
          v-for="cert in certificatesList"
          :key="`${cert}`"
          class="flex items-center py-1 checkbox-wrapper"
          @click="selectCertificate(cert)"
        >
          <input
            type="checkbox"
            :value="cert"
            v-model="selectedCertifications"
            class="w-5 h-5"
          >
          <span class="checkmark" />
          <span class="pl-4">{{ cert }}</span>
        </div>
      </div>
    </div>
    <div class="pt-3" v-if="certificatesList.length > 6">
      <p
        v-if="showAll"
        class="text-green underline cursor-pointer"
        @click="showAll = false"
      >
        Show Less
      </p>
      <p
        v-else
        class="text-green underline cursor-pointer"
        @click="showAll = true"
      >
        Show All ({{ certificatesList.length }})
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      certifications: {
        type: Array
      },
      type: {
        type: String
      }
    },
    data() {
      return {
        selectedCertifications: [],
        duns: false,
        drs: false,
        keyword: '',
        showAll: false
      }
    },
    computed: {
      extraSupplierCertificatesCheck() {
        if (this.type !== "Supplier") return false
        if ('duns'.includes(this.keyword.toLowerCase()) || 'drs'.includes(this.keyword.toLowerCase())) return true
        return false
      },
      certificatesList() {
        return this.keyword ? this.filteredCertificates : this.certifications
      },
      filteredCertificates() {
        return this.certifications.filter(cer => {
          return cer.toLowerCase().includes(this.keyword.toLowerCase())
        })
      }
    },
    methods: {
      selectCertificate(val) {
        const index = this.selectedCertifications.indexOf(val)
        if (index === -1) { 
          this.selectedCertifications.push(val) 
        } else {
          this.selectedCertifications.splice(index, 1)
        }
        this.$emit('updateCertifications', this.type, this.selectedCertifications)
      },
      selectDuns() {
        this.duns = !this.duns
        this.$emit('dunsChanged', this.duns)
      },
      selectDrs() {
        this.drs = !this.drs
        this.$emit('drsChanged', this.drs)
      }
    }
  }
</script>

